import React from 'react';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { useAccordionListStateContext, setCollection, useAccordionListDispatchContext } from 'Components/UI/TabularAccordionList/AccordionListContext';
import MetaQueryForm from 'Components/UI/Meta/MetaQueryForm';
import { minFutureAccomplishments, minPastAccomplishments } from 'Consts/accomplishments';


function ClientExperienceQueryWidget({ classes }) {
  const { collection } = useAccordionListStateContext();
  const dispatch = useAccordionListDispatchContext();

  return (
    <div className={classes.root}>
      {collection && <MetaQueryForm
        collection={collection}
        onSubmit={async (url) => {
          const nextLink = new fr.Link({
            data: {
              name: 'self',
              url,
            },
          });
          const nextCollection = await nextLink.get();
          setCollection(dispatch, nextCollection);
        }}
        defaultFilters={{
          householdStatus: {
            value: '2',
          },
          missingAccomplishments: {
            value: false,
          },
        }}
        availableFilters={collection ? [{
          name: 'householdId', // picklist
          query: 'getClientExperienceHouseholds',
        }, {
          name: 'leadPlannerAgentId', // picklist
          query: 'getClientExperienceHouseholds',
        }, {
          name: 'renewalDateStart',
          query: 'getClientExperienceHouseholds',
        }, {
          name: 'renewalDateEnd',
          query: 'getClientExperienceHouseholds',
        },
        {
          name: 'paymentFrequency',
          query: 'getClientExperienceHouseholds',
        },
        {
          name: 'missingAccomplishments',
          query: 'getClientExperienceHouseholds',
          helperText: `Minimum is ${minPastAccomplishments} accomplishments and ${minFutureAccomplishments} best next steps`,
        }] : []}
      />}
    </div>
  );
}

ClientExperienceQueryWidget.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
}))(ClientExperienceQueryWidget);
